import { getApiBaseUrl } from 'api';
import { Access } from 'types/types';

// API 기본 경로 생성 함수
export const wormApiUrl = (access: Access) =>
  `${getApiBaseUrl(access)}/web/railDevice`;
